import React from 'react'
import { compose } from 'recompose'
import { connect } from 'react-redux'
import { makeStyles } from '@material-ui/styles'
import { injectIntl } from 'react-intl'
import Typography from '@material-ui/core/Typography'
import { Grid } from '@material-ui/core'
import { caseImagesSelector } from '../../../../redux/selectors'
import emptyIcon from '../../../../assets/images/empty-images.svg'

const useStyles = makeStyles((theme) => ({
	titleRoot: {
		flexGrow: 1,
		width: '100%',
		color: 'black',
		fontSize: '28px',
		paddingTop: '16px',
		letterSpacing: '0.25px',
		textAlign: 'center',

		[theme.breakpoints.down('sm')]: {
			fontSize: '22px',
			padding: '16px',
			margin: '0 -16px',
			width: 'calc(100% + 32px)',
		},
	},
	gridInner: {
		marginTop: '100px',
		marginBottom: '100px',
		justifyContent: 'center',
		[theme.breakpoints.down('sm')]: {
			marginTop: '50px',
			marginBottom: '50px',
		},
		textAlign: 'center',
	},
	emptyTitle: {
		flex: 1,
		[theme.breakpoints.down('sm')]: {
			flex: 1,
		},
	}
}))

const EmptyImages = ({ intl, caseImages }) => {
	const classes = useStyles()

	return (
		<Grid data-testid="empty-images" container alignItems="center" justify="center" >
			<Grid item xs={12}>
				<div >
					<Grid container direction='column' alignItems='center'>
						<Grid container className={classes.gridInner}>
							<Grid data-testid="empty-images-title" item xs={12} sm={7} className={classes.emptyTitle}>
								<img alt="Empty Icon" src={emptyIcon}></img>
								<Typography variant='h2' className={classes.titleRoot} data-testid="empty-images-title-inner">
									{caseImages && caseImages.hasImageQuestions ? intl.formatMessage({ id: 'app.images.noImagesUploaded' }) : intl.formatMessage({ id: 'app.images.noImages' })}
								</Typography>
							</Grid>
						</Grid>
					</Grid>
				</div>
			</Grid>
		</Grid>
	)
}

const mapStateToProps = (state, ownProps) => ({
	caseImages: caseImagesSelector(state)
})

const mapDispatchToProps = () => ({})

const enhance = compose(connect(mapStateToProps, mapDispatchToProps), injectIntl)

export default enhance(EmptyImages)
